export const TAXONOMY_FULL_DEPTH = 7;
